import { addMeeting, editMeeting, getUserUnitList } from "../../../api/meeting/meeting";
import { Button } from "../../Button";
import { Col, Row } from "react-grid-system";
import { DatePicker } from "../../DatePicker";
import { Field, Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { Loader } from "../../Loader";
import { Select } from "../../Select";
import { StyledField } from "../../../styles/StyledField";
import { StyledUnitActions } from "../../../styles/StyledUnit";
import { useEffect } from "react";
import { useMeetingContext } from "../../../context/meetingContext";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import enGB from "date-fns/locale/en-GB";
import Modal from "react-modal";
import PropTypes from "prop-types";
import SaveIcon from "../../../assets/img/icons/save.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function MeetingHeaderEdit({ edit, newMeeting, disableEditingMode, refetch }) {
	const { id, title, place, organizationUnit, startDate, endDate } = useMeetingContext();
	const navigate = useNavigate();
	const { axiosPrivate } = useAxiosPrivate();

	const { data: unitList, isLoading: isLoadingUnitList } = useQuery("unitList", () => getUserUnitList(axiosPrivate));

	useEffect(() => {
		Modal.setAppElement("body");
	});

	const initialValues = {
		title: title ? title : "",
		place: place ? place : "",
		organizationUnit: organizationUnit ? organizationUnit.id.toString() : "1",
		startDate: startDate ? startDate : null,
		endDate: endDate ? endDate : null,
	};

	const submitHandler = (values) => {
		if (newMeeting) {
			const resultData = { ...values, guestUnits: [], guestUsers: [], creator: undefined };
			addMeeting(axiosPrivate, navigate, resultData);
		}
		if (!newMeeting) {
			editMeeting(axiosPrivate, id, { ...values, creator: undefined }, refetch);
		}
		disableEditingMode();
		refetch();
	};

	return (
		<>
			<Formik initialValues={initialValues} onSubmit={(values) => submitHandler(values)}>
				{({ values, setFieldValue }) => (
					<Form>
						<Row>
							<Col sm={5}>
								<StyledField edit>
									<label>Title</label>
									<Field as="textarea" id="title" name="title" data-testid="title" />
								</StyledField>
							</Col>
							<Col sm={6} offset={{ sm: 1 }}>
								<Row>
									<Col sm={6} xl={6} xxxl={6}>
										<StyledField edit>
											<label>Start date</label>
											<DatePicker
												id="startDate"
												locale={enGB}
												name="startDate"
												data-testid="startDate"
												autoComplete="off"
												showTimeSelect={true}
											/>
										</StyledField>
									</Col>
									<Col sm={6} xl={6} xxxl={6}>
										<StyledField edit>
											<label>End date</label>
											<DatePicker
												id="endDate"
												locale={enGB}
												name="endDate"
												data-testid="endDate"
												autoComplete="off"
												showTimeSelect={true}
											/>
										</StyledField>
									</Col>
								</Row>
								<Row>
									<Col sm={12}>
										<StyledField mb="12px" edit>
											<label>Unit</label>
											{isLoadingUnitList ? (
												<>
													<Loader />
													<input type="text" />
												</>
											) : (
												<Select
													options={unitList.map((el) => {
														return { value: el.id, label: el.name, matters: el.matters };
													})}
													value={values.unit}
													onChange={setFieldValue}
													id="organizationUnit"
													name="organizationUnit"
													data-testid="organizationUnit"
													dateFormat="yyyy-MM-dd h:mm"
												/>
											)}
										</StyledField>
									</Col>
								</Row>
								<Row>
									<Col sm={12}>
										<StyledField mb="12px" edit>
											<label>Place</label>
											<Field id="place" name="place" data-testid="place" />
										</StyledField>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={5}>
								<StyledUnitActions>
									{newMeeting && <Link to="/">Cancel</Link>}
									{edit && (
										<Button onClick={disableEditingMode} bg={false} small={true}>
											Cancel
										</Button>
									)}
									<Button type="submit" icon={SaveIcon}>
										Save changes
									</Button>
								</StyledUnitActions>
							</Col>
						</Row>
					</Form>
				)}
			</Formik>
		</>
	);
}

MeetingHeaderEdit.propTypes = {
	data: PropTypes.object,
	disableEditingMode: PropTypes.func,
	refetch: PropTypes.func,
	edit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	newMeeting: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
